/** Course catalog, independent of the interface language list: Japanese is taught,
 * while Polish and Bulgarian currently have interface copy but no course. */
export const LANGUAGE_COURSES = [
  { code: 'en' }, { code: 'pt' }, { code: 'nl' }, { code: 'es' },
  { code: 'fr' }, { code: 'de' }, { code: 'it' }, { code: 'ja' },
] as const;
export type LanguageCourseCode = typeof LANGUAGE_COURSES[number]['code'];
export const LANGUAGE_COURSE_CODES: readonly LanguageCourseCode[] = LANGUAGE_COURSES.map(course => course.code);
